import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsCategoryManager } from "../managers/categoryManager";
import { KidsGridIcon } from "../model/GridIcon";
import { KidsUtil } from "../utils";
import { KidsBaseGridView } from "./BaseGridView";

/**
 * tlc.ls2kids.views.CategoryView
 * The main home screen contains the category icon grid layout.
 */
export class KidsCategoryView extends KidsBaseGridView {
	constructor() {
		super({
			baseTemplate: 'tmpl/kids/category/categoryView.html',
			id: LS2KIDS_CONSTANTS.Ids.gridPage.main,
			targetId: LS2KIDS_CONSTANTS.Ids.mainContent,
			viewClass: 'baseView',

			scrollWrapperId: LS2KIDS_CONSTANTS.Ids.categoryPage.categoryScrollWrapper,
			listId: LS2KIDS_CONSTANTS.Ids.categoryPage.categoryList,
			itemConstructor: KidsGridIcon,

			absoluteCenter: true,

			distributeMargin: 0.2,
			distributeSize: 0.8,

			distributeMarginEvenly: true,
			distributeSizeEvenly: true,
			analyticsTrackingName: "category"
		});

		this._desiredFullCellHeight = 100;
		this._desiredFullCellWidth = 100;

		this._desiredIconRowMargin = 20;
		this._desiredIconColMargin = 20;

		this._addListeners();
	}
	/**
	 * When the template is rendered, we want to add the icons.
	 *
	 * @override
	 */
	baseTemplateRenderCallback() {
		super.baseTemplateRenderCallback(arguments);

		//	var _this = this;
		//	var happened = false;
		//
		//	window.requestAnimationFrame( function() {
		//		_this._seriesScrollWrapperEle.removeClass( 'hide-icons' );
		//
		//		var showIcons = function() {
		//			if( !happened ) {
		//				happened = true;
		//
		//				for( var i = 0, len = _this._gridIcons.length; i < len; i += 1 ) {
		//					_this._gridIcons[ i ].show();
		//				}
		//			}
		//		};
		//
		//		_this._seriesScrollWrapperEle.one( 'transitionend webkitTransitionEnd', showIcons );
		//		setTimeout( showIcons, 800 );
		//	} );
	}
	/**
	 * When the view loads, we refresh the grid to be sure things are aligned properly.
	 *
	 * @override
	 */
	load() {
		super.load(arguments);

		TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onCategoryViewStarted);
	}
	/**
	 * Add all events to handle showing/hiding this view.
	 *
	 * @private
	 */
	_addListeners() {
		this.setShowEvent(LS2KIDS_CONSTANTS.Events.onStartCategoryView);

		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartSeriesView);
		this.setHideEvent(LS2PAC_CONSTANTS.Events.onSearch);
	}
	/**
	 * Refresh the grid. Will guarantee it shows properly.
	 */
	refreshGrid() {
		super.refreshGrid(arguments);

		TLCEventManager.fireEvent(LS2KIDS_CONSTANTS.Events.onCategoryGridRefresh, {
			rows: this._rows,
			cols: this._columns
		});
	}
	_getItemById(categoryId) {
		return KidsCategoryManager.getCategory(categoryId);
	}
	_getLayout() {
		var categories = KidsCategoryManager.getCategories();

		var ordering = [];

		var index = 0;

		while (categories.length > 0) {
			var category = KidsUtil.puntRandom(categories);

			ordering.push({
				"id": category.id,
				"index": index
			});

			index += 1;
		}

		return ordering;
	}
}







